export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgotpassword',
  RESET_PASSWORD: '/resetpassword',
  UPCOMING_EVENTS: '/upcoming-events',
  REGISTRATIONS: '/registrations',
  USERS: '/users',
  STATISTICS: '/statistics',
  PRICES: '/prices',
  TEXTBLOCK_EDITOR: '/textblockeditor',
  DOCS_ORGA: '/docs/orga',
  DOCS_ADMIN: '/docs/admin',
  MAIL_QUEUE: '/mailqueue',
  EVENT_ANNOUNCEMENT: '/eventannouncement',
  LOCATIONS: '/locations',
  PARTICIPANT_GROUPS: '/groups',
  PROCESS_TEMPLATES: '/processtemplates',
  FLAT_RATES: '/flatrates',

  // Base segment used for startsWith checks
  EVENT_BASE: '/event',
  WIKI_BASE: '/wiki',

  // Dynamic builders
  event: (eventId, eventDate) => `/event/${eventId}/${eventDate}`,
  wiki: (wikiId) => `/wiki/${wikiId}`,
  user: (playerId) => `/users/${playerId}`,
  mail: (eventId, playerId) => `/mail/${eventId}/${playerId}`,
  mailPlayer: (playerId) => `/mail/player/${playerId}`,
  roundmail: (eventId) => `/roundmail/${eventId}`,
  statisticsForEvent: (eventId) => `/statistics?eventId=${eventId}`,
};

// React Router path patterns for <Route path=...>
export const ROUTE_PATTERNS = {
  EVENT: '/event/:eventId/:eventDate',
  WIKI: '/wiki/:wikiId',
  USER: '/users/:playerId',
  MAIL: '/mail/:eventId/:playerId',
  MAIL_PLAYER: '/mail/player/:playerId',
  ROUNDMAIL: '/roundmail/:eventId',
};
